import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { FluentProvider } from '@fluentui/react-components'
import { App } from './app/App'
import { ErrorBoundary } from './app/ErrorBoundary'
import { initializeMsal, msalInstance } from './services/auth/msalInstance'
import { socCopilotTheme } from './config/theme'
import './styles/global.css'

const rootElement = document.getElementById('root')!
const root = createRoot(rootElement)

function renderApp() {
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <FluentProvider theme={socCopilotTheme} style={{ height: '100%' }}>
            <App />
          </FluentProvider>
        </MsalProvider>
      </ErrorBoundary>
    </StrictMode>,
  )
}

initializeMsal()
  .catch((error) => console.error('MSAL initialization failed:', error))
  .finally(renderApp)
